import { isElementVisible, scrollIntoView } from '../../shared/utils/dom';

export const setReadMoreListeners = (
  descriptionWrapperSelector: string = '.js-description-wrapper',
  toggleReadButtonSelector: string = '.js-toggle-read-more'
): void => {
  const descriptionWrapper = document.querySelector<HTMLElement>(
    descriptionWrapperSelector
  );
  const readMoreButton = document.querySelector<HTMLButtonElement>(
    toggleReadButtonSelector
  );

  if (!descriptionWrapper || !readMoreButton) {
    return;
  }

  readMoreButton.addEventListener('click', () => {
    descriptionWrapper.classList.toggle('hb-description-open');
    const isOpen = descriptionWrapper.classList.contains('hb-description-open');
    readMoreButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (!isOpen && !isElementVisible(descriptionWrapper)) {
      requestAnimationFrame(() => {
        scrollIntoView(descriptionWrapper, 120);
      });
    }
  });
};
